// ==============================
// GLOBAL CONFIG
// ==============================
function safeStringConfig(key) {
    try {
        if (typeof PM !== "undefined" && typeof PM.Get === "function") {
            const val = PM.Get("Application", key);
            if (val !== null && val !== undefined && val !== "null" && val !== "undefined" && val.toString().trim() !== "") {
                return String(val).trim();
            }
        }
    } catch (e) { }
    return null;
}

window.ga4_id = safeStringConfig("ga4");
window.gtm_id = safeStringConfig("gtagID");
window.fb_id = safeStringConfig("facebook_pixel_id");
window.ads_id = safeStringConfig("google_ads_id");
window.ads_label = safeStringConfig("google_ads_conversion_label");
window.openai_id = safeStringConfig("openai_pixel_id");

window.dataLayer = window.dataLayer || [];

// ==============================
// EVENT HOOK - TRACKING DEBUG PANEL
// ==============================

(function () {

    // ==============================
    // CONFIG
    // ==============================
    const STORAGE_KEY = "__tracking_logs__";
    const MAX_LOG = 200;

    function isDebugActive() {
        return location.search.includes("debug_tracking=1") ||
            localStorage.getItem("debug_tracking") === "1";
    }

    function updateAdminBarButton(isActive) {
        const btn = document.getElementById("pm_admin_toggle_debug");
        if (btn) {
            btn.innerHTML = `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${isActive ? '#28a745' : '#adb5bd'};margin-right:5px;"></span>Tracking Debug: ${isActive ? 'Açık' : 'Kapalı'}`;
        }
    }

    // ==============================
    // STORAGE HELPERS
    // ==============================
    function getLogs() {
        try {
            return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
        } catch (e) {
            return [];
        }
    }

    function saveLogs(logs) {
        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
        } catch (e) { }
    }

    // ==============================
    // DATALAYER HOOK
    // ==============================
    window.dataLayer = window.dataLayer || [];

    const originalPush = window.dataLayer.push;

    window.__logTrackingEvent = function (dest, eventName, payload) {
        try {
            const logs = getLogs();
            const log = {
                dest: dest,
                event: eventName,
                payload: payload,
                time: new Date().toISOString(),
                url: location.pathname,
                page: (window.PM && PM.ActionPage) || ""
            };
            logs.push(log);
            if (logs.length > MAX_LOG) logs.shift();
            saveLogs(logs);
            if (isDebugActive()) {
                console.log(`TRACK [${dest}]:`, log);
            }
            window.dispatchEvent(new CustomEvent("tracking:update", { detail: log }));
        } catch (e) { }
    };

    window.dataLayer.push = function () {

        const event = arguments[0];

        try {
            let eventName = event?.event || "unknown";
            let eventPayload = event;
            let dest = "GTM (DataLayer)";

            // Handle gtag(arguments) pushed to dataLayer
            if (event && (Array.isArray(event) || Object.prototype.toString.call(event) === '[object Arguments]')) {
                dest = "GA4 (gtag.js)";
                const argsArray = Array.from(event);
                if (argsArray[0] === 'event' && argsArray[1]) {
                    eventName = argsArray[1];
                } else if (typeof argsArray[0] === 'string') {
                    eventName = argsArray[0]; // e.g. "set", "js", "config"
                }
                eventPayload = argsArray;
            }

            window.__logTrackingEvent(dest, eventName, eventPayload);

        } catch (e) { }

        return originalPush.apply(window.dataLayer, arguments);
    };

    // Retroactive logging for items pushed before this script loaded
    if (Array.isArray(window.dataLayer)) {
        window.dataLayer.forEach(function (event) {
            try {
                let eventName = event?.event || "unknown";
                let eventPayload = event;
                let dest = "GTM (DataLayer)";
                if (event && (Array.isArray(event) || Object.prototype.toString.call(event) === '[object Arguments]')) {
                    dest = "GA4 (gtag.js)";
                    const argsArray = Array.from(event);
                    if (argsArray[0] === 'event' && argsArray[1]) {
                        eventName = argsArray[1];
                    } else if (typeof argsArray[0] === 'string') {
                        eventName = argsArray[0];
                    }
                    eventPayload = argsArray;
                }
                // Only log gtag config/consent or important early events to avoid spam
                if (dest === "GA4 (gtag.js)" || eventName !== "unknown") {
                    window.__logTrackingEvent(dest, eventName, eventPayload);
                }
            } catch (e) { }
        });
    }

    // ==============================
    // PANEL UI CREATE & CSS
    // ==============================
    let styleInjected = false;
    function injectStyle() {
        if (styleInjected || document.getElementById("td-style")) return;
        styleInjected = true;
        const style = document.createElement("style");
        style.id = "td-style";
        style.innerHTML = `
            #tracking-debug-panel {
                position: fixed;
                bottom: 10px;
                right: 10px;
                width: 380px;
                height: 520px;
                background: #111;
                color: #0f0;
                font-size: 12px;
                z-index: 999999;
                border-radius: 8px;
                overflow: hidden;
                font-family: Consolas, Monaco, "Courier New", monospace;
                box-shadow: 0 4px 20px rgba(0,0,0,0.6);
                border: 1px solid #3f3f46;
            }

            .td-header {
                padding: 10px 12px;
                background: #27272a;
                color: #22c55e;
                font-weight: bold;
                font-size: 13px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #3f3f46;
            }

            #td-close {
                cursor: pointer;
                background: #3f3f46;
                color: #f4f4f5;
                border: 1px solid #52525b;
                padding: 2px 8px;
                border-radius: 4px;
                font-size: 11px;
                font-weight: bold;
            }
            #td-close:hover {
                background: #ef4444;
                color: #fff;
                border-color: #dc2626;
            }

            .td-filters {
                padding: 8px 10px;
                background: #18181b;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #27272a;
            }

            .td-filters input {
                flex: 1;
                padding: 6px 8px;
                background: #27272a;
                color: #f4f4f5;
                border: 1px solid #3f3f46;
                border-radius: 4px;
                font-size: 11px;
                outline: none;
            }
            .td-filters input:focus {
                border-color: #22c55e;
            }

            .td-filters button {
                margin-left: 6px;
                padding: 6px 10px;
                background: #3f3f46;
                color: #f4f4f5;
                border: 1px solid #52525b;
                border-radius: 4px;
                cursor: pointer;
                font-size: 11px;
            }
            .td-filters button:hover {
                background: #52525b;
            }

            #td-list {
                overflow-y: auto;
                height: 410px;
                padding: 10px;
                background: #09090b;
            }

            .td-item {
                margin-bottom: 12px;
                border-bottom: 1px solid #27272a;
                padding-bottom: 10px;
            }

            .td-item[data-event="purchase"] {
                background: rgba(34, 197, 94, 0.1);
                border-left: 3px solid #22c55e;
                padding-left: 8px;
            }

            #tracking-debug-panel pre {
                background: #18181b !important;
                color: #f4f4f5 !important;
                padding: 8px 10px !important;
                border-radius: 6px !important;
                border: 1px solid #27272a !important;
                font-size: 11px !important;
                line-height: 1.45 !important;
                max-height: 250px !important;
                overflow-x: auto !important;
                overflow-y: auto !important;
                margin: 6px 0 2px 0 !important;
                font-family: Consolas, Monaco, "Courier New", monospace !important;
                white-space: pre-wrap !important;
                word-break: break-word !important;
            }

            #td-list::-webkit-scrollbar,
            #tracking-debug-panel pre::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            #td-list::-webkit-scrollbar-thumb,
            #tracking-debug-panel pre::-webkit-scrollbar-thumb {
                background: #3f3f46;
                border-radius: 3px;
            }
            #td-list::-webkit-scrollbar-track,
            #tracking-debug-panel pre::-webkit-scrollbar-track {
                background: #18181b;
            }
        `;
        document.head.appendChild(style);
    }

    function syntaxHighlight(json) {
        if (typeof json !== 'string') {
            json = JSON.stringify(json, null, 2);
        }
        if (!json) return '';
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            let color = '#a3e635'; // number (lime green)
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    color = '#38bdf8'; // property key (bright sky blue)
                } else {
                    color = '#fbbf24'; // string value (warm amber)
                }
            } else if (/true|false/.test(match)) {
                color = '#c084fc'; // boolean (purple)
            } else if (/null/.test(match)) {
                color = '#94a3b8'; // null (gray)
            }
            return '<span style="color:' + color + ';">' + match + '</span>';
        });
    }

    function createPanel() {
        injectStyle();
        let panel = document.getElementById("tracking-debug-panel");
        if (panel) return panel;

        panel = document.createElement("div");
        panel.id = "tracking-debug-panel";

        panel.innerHTML = `
            <div class="td-header">
                Tracking Debug
                <button id="td-close">X</button>
            </div>
            <div class="td-filters">
                <input id="td-search" placeholder="event ara..." />
                <button id="td-clear">Temizle</button>
            </div>
            <div id="td-list"></div>
        `;

        document.body.appendChild(panel);
        return panel;
    }

    // ==============================
    // RENDER
    // ==============================
    function render(log) {

        const list = document.getElementById("td-list");
        if (!list) return;

        const el = document.createElement("div");
        el.className = "td-item";
        el.setAttribute("data-event", log.event);

        const destColor = log.dest === "Meta Pixel" ? "#1877F2" :
            (log.dest === "GA4 (gtag.js)" ? "#F9AB00" :
                (log.dest === "Google Ads" ? "#34A853" :
                    (log.dest === "OpenAI Ads" ? "#10A37F" : "#4285F4")));

        const timeStr = log.time ? log.time.split('T')[1].replace('Z', '') : '';

        el.innerHTML = `
            <div style="margin-bottom:5px; display:flex; justify-content:space-between; align-items:center;">
                <span style="background:${destColor}; color:#fff; padding:2px 6px; border-radius:3px; font-size:10px; font-weight:bold;">${log.dest || 'Unknown'}</span>
                <span style="color:#71717a; font-size:10px;">${timeStr}</span>
            </div>
            <div style="color:#f4f4f5; font-size:13px; font-weight:bold; margin-bottom:2px;">
                <span style="color:#22c55e;">${log.event}</span> 
                <span style="color:#a1a1aa; font-size:11px; font-weight:normal;">(${log.page || 'genel'})</span>
            </div>
            <div style="color:#60a5fa; font-size:11px; margin-bottom:2px; word-break:break-all;">${log.url}</div>
            <pre>${syntaxHighlight(log.payload)}</pre>
        `;

        list.prepend(el);
    }

    // ==============================
    // LOAD OLD LOGS
    // ==============================
    function loadExistingLogs() {
        const logs = getLogs();
        const list = document.getElementById("td-list");
        if (list) list.innerHTML = "";
        logs.forEach(render);
    }

    // ==============================
    // TOGGLE FUNCTION
    // ==============================
    window.toggleTrackingDebug = function (forceState) {
        const currentState = isDebugActive();
        const nextState = (forceState !== undefined) ? !!forceState : !currentState;

        if (nextState) {
            localStorage.setItem("debug_tracking", "1");
            const panel = createPanel();
            if (panel) panel.style.display = "block";
            loadExistingLogs();
        } else {
            localStorage.setItem("debug_tracking", "0");
            const panel = document.getElementById("tracking-debug-panel");
            if (panel) panel.style.display = "none";
        }

        updateAdminBarButton(nextState);
        return nextState;
    };

    // ==============================
    // EVENTS
    // ==============================
    window.addEventListener("tracking:update", function (e) {
        render(e.detail);
    });

    document.addEventListener("input", function (e) {

        if (e.target.id !== "td-search") return;

        const val = e.target.value.toLowerCase();

        document.querySelectorAll(".td-item").forEach(el => {
            el.style.display = el.innerText.toLowerCase().includes(val)
                ? "block"
                : "none";
        });
    });

    document.addEventListener("click", function (e) {

        if (e.target.id === "td-clear") {
            sessionStorage.removeItem(STORAGE_KEY);
            const list = document.getElementById("td-list");
            if (list) list.innerHTML = "";
        }

        if (e.target.id === "td-close") {
            window.toggleTrackingDebug(false);
        }

    });

    // ==============================
    // INIT
    // ==============================
    window.addEventListener("DOMContentLoaded", function () {
        if (isDebugActive()) {
            createPanel();
            loadExistingLogs();
        }
        updateAdminBarButton(isDebugActive());
    });

})();

// ==============================
// ENV
// ==============================
var ENV = window.ENV || {
    hasGA4: !!window.ga4_id,
    hasGTM: !!window.gtm_id,
    hasFB: !!window.fb_id,
    hasAds: !!window.ads_id,
    hasOpenAI: !!window.openai_id
};

// ==============================
// DEBUG LOGGER
// ==============================
function debugLog(msg, ...args) {
    const isDebugActive = location.search.includes("debug_tracking=1") || localStorage.getItem("debug_tracking") == "1";
    if (!isDebugActive) return;

    if (window.console && console.log) {
        console.log(`[TRACKING DEBUG] ${msg}`, ...args);
    }
}

// ==============================
// CORE TRACKING
// ==============================
function trackEvent(eventName, payload = {}) {
    debugLog("trackEvent Çağrıldı", eventName, payload);
    window.dataLayer.push({ event: eventName, ...payload });
    GA4Adapter(eventName, payload);
    FBAdapter(eventName, payload);
    GoogleAdsAdapter(eventName, payload);
    OpenAIAdapter(eventName, payload);
}

// ==============================
// ADAPTER DEBUG
// ==============================
function GA4Adapter(eventName, payload) {
    if (ENV.hasGTM) return debugLog("GTM devrede, gtag adapter'a gerek yok.");
    if (!ENV.hasGA4) return debugLog("GA4 adapter devreye girmedi");
    if (typeof window.gtag !== "function") return debugLog("GA4 gtag yok");

    const data = payload.ecommerce || payload;
    debugLog("GA4Adapter tetiklendi", eventName, data);

    window.gtag("event", eventName, data);
}

// ==============================
// META ADAPTER
// ==============================
var FB_EVENT_MAP = {
    page_view: "PageView",
    view_item: "ViewContent",
    add_to_cart: "AddToCart",
    begin_checkout: "InitiateCheckout",
    add_payment_info: "AddPaymentInfo",
    purchase: "Purchase",
    search: "Search",
    view_cart: "ViewContent",
    sign_up: "CompleteRegistration"  // Üye kayıt eventi
};

function FBAdapter(eventName, payload) {
    if (!ENV.hasFB || typeof window.fbq !== "function") return debugLog("FB adapter devreye girmedi", eventName);

    const fbEvent = FB_EVENT_MAP[eventName];
    if (!fbEvent) return debugLog("FB event map bulunamadı", eventName);

    const e = payload.ecommerce;
    let fbPayload = {};

    if (e && (eventName !== "page_view" && eventName !== "search")) {
        const rawItems = Array.isArray(e.items) ? e.items : [];
        const validContents = [];
        const validContentIds = [];

        rawItems.forEach(function (i) {
            const rawId = i.item_id !== undefined && i.item_id !== null ? i.item_id : (i.id !== undefined && i.id !== null ? i.id : "");
            const cleanId = String(rawId).trim();
            if (cleanId !== "") {
                validContents.push({
                    id: cleanId,
                    quantity: parseInt(i.quantity, 10) || 1,
                    item_price: parsePrice(i.price)
                });
                validContentIds.push(cleanId);
            }
        });

        fbPayload = {
            value: parsePrice(e.value || 0),
            currency: e.currency || "TRY",
            content_type: "product",
            contents: validContents,
            content_ids: validContentIds
        };

        // content_name: Tekil ürün işlemlerinde ürün adını ekle
        if (rawItems.length === 1 && rawItems[0].item_name) {
            fbPayload.content_name = String(rawItems[0].item_name).trim();
        } else if (payload.content_name) {
            fbPayload.content_name = String(payload.content_name).trim();
        }
    } else if (eventName === 'search') {
        fbPayload = { search_string: payload.search_term };
    }

    const finalPayload = Object.keys(fbPayload).length > 0 ? fbPayload : undefined;
    window.fbq("track", fbEvent, finalPayload);
    debugLog("FBAdapter tetiklendi", fbEvent, finalPayload);

    if (window.__logTrackingEvent) {
        window.__logTrackingEvent("Meta Pixel", fbEvent, finalPayload || {});
    }
}


// ==============================
// GOOGLE ADS ADAPTER
// ==============================
function GoogleAdsAdapter(eventName, payload) {
    if (!ENV.hasAds) return debugLog("Google Ads adapter devreye girmedi");
    if (typeof window.gtag !== "function") return debugLog("Google Ads gtag yok");

    const e = payload.ecommerce || payload;

    if (eventName === 'purchase') {
        const sendTo = window.ads_label ? `${window.ads_id}/${window.ads_label}` : window.ads_id;

        const conversionPayload = {
            'send_to': sendTo,
            'value': e.value || 0,
            'currency': e.currency || 'TRY',
            'transaction_id': e.transaction_id || ''
        };

        // Gelişmiş Dönüşümler (Enhanced Conversions) - Opsiyonel
        if (window.customer_email || window.customer_phone) {
            conversionPayload.user_data = {};
            if (window.customer_email) conversionPayload.user_data.email = window.customer_email;
            if (window.customer_phone) conversionPayload.user_data.phone_number = window.customer_phone;
        }

        window.gtag('event', 'conversion', conversionPayload);
        debugLog("Google Ads Conversion tetiklendi", conversionPayload);

        if (window.__logTrackingEvent) {
            window.__logTrackingEvent("Google Ads", "conversion", conversionPayload);
        }
    }
}


// ==============================
// OPENAI ADS ADAPTER (ChatGPT Ads)
// ==============================
function OpenAIAdapter(eventName, payload) {
    if (!ENV.hasOpenAI || typeof window.oaiq !== "function") return debugLog("OpenAI adapter devreye girmedi", eventName);

    const e = payload.ecommerce || payload;
    const rawItems = Array.isArray(e.items) ? e.items : [];
    const validContents = [];

    rawItems.forEach(function (i) {
        const rawId = i.item_id !== undefined && i.item_id !== null ? i.item_id : (i.id !== undefined && i.id !== null ? i.id : "");
        const cleanId = String(rawId).trim();
        if (cleanId !== "") {
            const itemName = String(i.item_name || "").trim();
            const itemAmount = Math.round(parsePrice(i.price) * 100); // minor unit (kuruş), integer zorunlu

            // SDK ps alanları: ["id","name","content_type","quantity","amount","currency"]
            // "item_price" geçersiz → "amount" kullan
            // "name" boş string olursa SDK X() validation'ı fail eder → sadece doluysa ekle
            const contentItem = {
                id: cleanId,
                content_type: "product",
                quantity: parseInt(i.quantity, 10) || 1,
                amount: itemAmount      // minor unit integer (item_price değil!)
            };
            if (itemName) contentItem.name = itemName; // sadece dolu ise ekle

            validContents.push(contentItem);
        }
    });


    const val = parsePrice(e.value || 0);
    const amountMinor = Math.round(val * 100);
    const currency = e.currency || "TRY";

    let oaiEvent = null;
    let oaiPayload = null;
    let oaiOptions = undefined;

    // ── SDK Validation Notları (oaiq.min.js kaynak kodu analizi) ──
    // Her event'in SDK'daki kategorisi (so objesi):
    //   page_viewed, contents_viewed, checkout_started, items_added, order_created → "contents"
    //   registration_completed → "customer_action"
    //   custom → "custom"
    //
    // Payload type değeri, event kategorisiyle EŞİT OLMALI:
    //   "contents" kategorisi  → type: "contents"
    //   "customer_action"      → type: "customer_action"
    //   "custom"               → type: "custom"
    //
    // "custom" event'te custom_event_name PAYLOAD'A değil OPTIONS'A (4. parametre) gitmeli:
    //   Payload allowed fields: ["type","plan_id","amount","currency","contents"]
    //   Options allowed fields: ["event_id","eventId","custom_event_name","opt_out"]

    if (eventName === "page_view") {
        oaiEvent = "page_viewed";
        // page_viewed → "contents" kategorisi → type: "contents" zorunlu
        oaiPayload = { type: "contents" };

    } else if (eventName === "view_item" || eventName === "view_cart") {
        oaiEvent = "contents_viewed";
        oaiPayload = {
            type: "contents",
            amount: amountMinor,
            currency: currency,
            contents: validContents
        };

    } else if (eventName === "add_to_cart") {
        oaiEvent = "items_added";
        oaiPayload = {
            type: "contents",
            amount: amountMinor,
            currency: currency,
            contents: validContents
        };

    } else if (eventName === "begin_checkout") {
        oaiEvent = "checkout_started";
        oaiPayload = {
            type: "contents",
            amount: amountMinor,
            currency: currency,
            contents: validContents
        };

    } else if (eventName === "add_shipping_info") {
        // custom event → type: "custom", custom_event_name options'a gidiyor
        oaiEvent = "custom";
        oaiPayload = {
            type: "custom",
            amount: amountMinor,
            currency: currency,
            contents: validContents
        };
        oaiOptions = { custom_event_name: "shipping_info_added" };

    } else if (eventName === "add_payment_info") {
        // custom event → type: "custom", custom_event_name options'a gidiyor
        oaiEvent = "custom";
        oaiPayload = {
            type: "custom",
            amount: amountMinor,
            currency: currency,
            contents: validContents
        };
        oaiOptions = { custom_event_name: "payment_info_added" };

    } else if (eventName === "purchase") {
        oaiEvent = "order_created";
        oaiPayload = {
            type: "contents",
            amount: amountMinor,
            currency: currency,
            contents: validContents
        };
        const transactionId = e.transaction_id || "";
        if (transactionId) {
            oaiOptions = { event_id: String(transactionId) };
        }

    } else if (eventName === "sign_up") {
        // registration_completed → "customer_action" kategorisi
        oaiEvent = "registration_completed";
        oaiPayload = { type: "customer_action" };

    } else if (eventName === "search") {
        // custom event → type: "custom", custom_event_name options'a gidiyor
        // search_string SDK'nın bilinen bir alanı değil, payload'dan çıkarılıyor
        oaiEvent = "custom";
        oaiPayload = { type: "custom" };
        oaiOptions = { custom_event_name: "search" };
    }

    if (oaiEvent && oaiPayload) {
        if (oaiOptions) {
            window.oaiq("measure", oaiEvent, oaiPayload, oaiOptions);
        } else {
            window.oaiq("measure", oaiEvent, oaiPayload);
        }
        debugLog("OpenAIAdapter tetiklendi", oaiEvent, oaiPayload, oaiOptions);

        if (window.__logTrackingEvent) {
            window.__logTrackingEvent("OpenAI Ads", oaiEvent, oaiOptions ? { ...oaiPayload, _options: oaiOptions } : oaiPayload);
        }
    }
}


// ==============================
// LOADERS WITH DEBUG
// ==============================
function loadGTM() {
    if (!ENV.hasGTM) return debugLog("GTM yok");
    debugLog("GTM yükleniyor", gtm_id);

    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s);

        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i;

        if (f && f.parentNode) {
            f.parentNode.insertBefore(j, f);
        } else {
            (d.head || d.documentElement).appendChild(j);
        }

        j.onload = function () {
            debugLog("GTM script yüklendi");
        };
    })(window, document, 'script', 'dataLayer', gtm_id);
}

function loadGA4() {
    // GTM aktif olsa bile gtag shim'i tanımla;
    // GoogleAdsAdapter'ın GTM ile birlikte dönüşüm gönderebilmesi için gerekli.
    if (!window.gtag) {
        window.gtag = function () { dataLayer.push(arguments); };
        debugLog("gtag shim tanımlandı");
    }

    if (!ENV.hasGA4) return debugLog("GA4 yok");
    if (ENV.hasGTM) return debugLog("GTM var, GA4 doğrudan yüklenmedi");

    const s = document.createElement("script");
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + ga4_id;
    s.async = true;
    s.onload = () => debugLog("GA4 script yüklendi");
    document.head.appendChild(s);

    gtag('js', new Date());
    gtag('config', ga4_id);
    debugLog("GA4 config gönderildi", ga4_id);

    // Google Ads (Yeniden Pazarlama / Remarketing) Config
    if (ENV.hasAds) {
        gtag('config', ads_id);
        debugLog("Google Ads config gönderildi (Remarketing)", ads_id);
    }
}

function getCookiePreferences() {
    try {
        const v = document.cookie.match('(^|;)\\s*cookie_preferences_v2\\s*=\\s*([^;]+)');
        return v ? JSON.parse(decodeURIComponent(v.pop())) : null;
    } catch (e) {
        return null;
    }
}

function loadFB() {
    if (!ENV.hasFB) return debugLog("FB Pixel yok");

    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        t = b.createElement(e); t.async = true; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
        t.onload = () => debugLog("FB Pixel script yüklendi");
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    const metaConsentActive = safeStringConfig("meta_consent_mode") === "1";
    if (metaConsentActive) {
        const prefs = getCookiePreferences();
        if (prefs && prefs.ads) {
            fbq('consent', 'grant');
            debugLog("Meta Pixel consent: grant (önceki onay mevcut)");
        } else {
            fbq('consent', 'revoke');
            debugLog("Meta Pixel consent: revoke (onay yok veya bekleniyor)");
        }
    }

    fbq('init', fb_id);
    debugLog("FB Pixel init edildi", fb_id);
}

function initOpenAIScript(isDeferred) {
    if (window._openai_initialized) return;
    window._openai_initialized = true;

    (function (w, d, s, u) {
        if (w.oaiq) return;
        var q = function () { q.q.push(arguments); };
        q.q = [];
        w.oaiq = q;
        var js = d.createElement(s);
        js.async = true;
        js.src = u;
        var f = d.getElementsByTagName(s)[0];
        if (f && f.parentNode) {
            f.parentNode.insertBefore(js, f);
        } else {
            (d.head || d.documentElement).appendChild(js);
        }
        js.onload = () => debugLog("OpenAI Pixel script yüklendi");
    })(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");

    oaiq("init", {
        pixelId: window.openai_id
    });
    debugLog("OpenAI Pixel init edildi", window.openai_id);

    if (isDeferred) {
        oaiq("measure", "page_viewed", { type: "page_view" });
        debugLog("OpenAI Pixel gecikmeli page_viewed gönderildi");
    }
}

function loadOpenAI() {
    if (!ENV.hasOpenAI) return debugLog("OpenAI Pixel yok");

    const openAiConsentActive = safeStringConfig("openai_consent_mode") === "1";
    if (openAiConsentActive) {
        const prefs = getCookiePreferences();
        if (!prefs || !prefs.ads) {
            debugLog("OpenAI Pixel rıza bekleniyor, yükleme bekletildi");
            const onConsentUpdated = function (e) {
                if (e && e.detail && e.detail.ads && !window._openai_initialized) {
                    window.removeEventListener('pm_consent_updated', onConsentUpdated);
                    initOpenAIScript(true);
                }
            };
            window.addEventListener('pm_consent_updated', onConsentUpdated);
            return;
        }
    }

    initOpenAIScript(false);
}


// ==============================
// INIT
// ==============================
(function () {

    const isDntActive = window.navigator?.doNotTrack === '1';
    const isPrivate = (['sifre_degistir'].indexOf(PM.ActionPage) > -1);

    if ((!ENV.hasGA4 && !ENV.hasFB && !ENV.hasGTM && !ENV.hasAds && !ENV.hasOpenAI) || isDntActive || isPrivate) {
        window.trackEvent = function () { };
        return;
    }

    loadGTM();
    loadGA4();
    loadFB();
    loadOpenAI();

    syncBasketSession();

    const qs = window.location.search
        ? getQueryVariable(window.location.search.substring(1))
        : {};

    // ==========================
    // SEARCH
    // ==========================
    PM.OnPage("arama_sonuclari", function () {
        trackEvent("search", {
            search_term: qs.word
        });
    });

    // ==========================
    // CLICK BASED ADD TO CART (LISTINGS) - AJAX COMPATIBLE (EVENT DELEGATION)
    // ==========================
    document.addEventListener("click", function (e) {
        // A etiketi, buton veya onclick içeren öğeleri yakala
        const target = e.target.closest(".urun a, .urun button, .urun [onclick], [data-action='add-to-cart'], a[href*='sepete_ekle'], a[href*='hizli_satin_al'], button[onclick*='sepete_ekle'], button[onclick*='HemenAl'], [onclick*='HizliSepeteEkle']");
        if (!target) return;

        // Ürün detay sayfasındaki ana form submit butonlarını atla (onlar PM.on("add.cart") ile işlenir)
        if (target.id === "sepete_ekle_buton" || target.id === "hemenal_buton" || target.closest("#urun_detay_sepete_ekle_form")) {
            return;
        }

        const href = target.getAttribute("href") || "";
        const onclick = target.getAttribute("onclick") || "";
        const dataId = target.getAttribute("data-id") || target.getAttribute("data-uid") || target.getAttribute("data-urun-id") || target.getAttribute("data-product-id") || "";
        const paramsStr = href + " " + onclick + " " + dataId;

        // Regex: Sepete ekle linkleri, Hemen Al veya HizliSepeteEkle fonksiyon çağrıları veya uid parametresi
        const match = paramsStr.match(/(?:[?&]islem=(?:sepete_ekle2?|hizli_satin_al_\w+).*?[?&]uid=([0-9]+))|(?:[?&]uid=([0-9]+).*?[?&]islem=(?:sepete_ekle2?|hizli_satin_al_\w+))|(?:PM\.HemenAl|hemenal_fonksiyon|PM\.HizliSepeteEkle|sepete_ekle|hizli_satinal)\s*\(\s*['"]?([0-9]+)['"]?\s*[\),]/i);

        let productId = "";
        if (match) {
            productId = match[1] || match[2] || match[3] || "";
        } else if (dataId && /^[0-9]+$/.test(dataId.trim())) {
            if (/sepete|ekle|buy|cart|hemen/i.test(paramsStr) || target.classList.contains("sepete_ekle") || target.classList.contains("hemen_al")) {
                productId = dataId.trim();
            }
        }

        const productEl = target.closest(".urun, .product-item, .urun_kutu, .vitrin_urun, tr.sepet_urun");

        if (!productId && productEl) {
            const dataLayerEl = productEl.querySelector("span.data-layer");
            if (dataLayerEl && dataLayerEl.getAttribute("data-id")) {
                if (/sepete|ekle|buy|cart|hemen/i.test(paramsStr) || target.classList.contains("sepete_ekle") || target.classList.contains("hemen_al")) {
                    productId = dataLayerEl.getAttribute("data-id");
                }
            }
            if (!productId) {
                const pmuLink = productEl.querySelector("a[href*='-pmu']");
                if (pmuLink) {
                    const pmuMatch = (pmuLink.getAttribute("href") || "").match(/-pmu([0-9]+)/i);
                    if (pmuMatch && (/sepete|ekle|buy|cart|hemen/i.test(paramsStr) || target.classList.contains("sepete_ekle") || target.classList.contains("hemen_al"))) {
                        productId = pmuMatch[1];
                    }
                }
            }
        }

        if (productId) {
            productId = String(productId).trim();
            let itemName = "";
            let price = 0;

            if (productEl) {
                const dataLayerEl = productEl.querySelector("span.data-layer");
                if (dataLayerEl) {
                    itemName = dataLayerEl.getAttribute("data-name") || "";
                    price = parsePrice(dataLayerEl.getAttribute("data-price") || "0");
                }

                if (!itemName) {
                    const nameLinkEl = productEl.querySelector(".urun_ismi a, .urun_adi a, .urun-title a, a[href*='-pmu']");
                    if (nameLinkEl) {
                        itemName = (nameLinkEl.getAttribute("title") || nameLinkEl.textContent).trim();
                    }
                }

                if (!price) {
                    const priceEl = productEl.querySelector(".urun_kdvdahil_fiyati, .urun_fiyati, [data-price-wt], .fiyat, .price");
                    if (priceEl) {
                        const rawPrice = priceEl.getAttribute("data-price-wt") || priceEl.getAttribute("data-price") || priceEl.textContent.trim();
                        price = parsePrice(rawPrice);
                    }
                }
            }

            const itemData = {
                item_id: productId,
                item_name: itemName,
                price: price,
                quantity: 1
            };

            trackEvent("add_to_cart", {
                ecommerce: {
                    currency: "TRY",
                    value: price,
                    items: [itemData]
                }
            });
            updateLocalCart(itemData, "add");

            // Eğer link doğrudan başka bir sayfaya yönlendiriyorsa (AJAX değilse),
            // tarayıcı sayfa değiştirdiği an Google/FB isteklerini iptal edebilir.
            // Bu yüzden yönlendirmeyi çok kısa süre bekletiyoruz.
            if (target.tagName.toLowerCase() === "a" && href && href !== "#" && !href.startsWith("javascript:")) {
                let userPrevented = false;
                const originalPreventDefault = e.preventDefault;

                // Diğer click event listener'larının preventDefault çağırıp çağırmadığını yakalıyoruz
                e.preventDefault = function () {
                    userPrevented = true;
                    originalPreventDefault.apply(this, arguments);
                };

                // Tarayıcının varsayılan yönlendirmesini hemen durduruyoruz
                originalPreventDefault.call(e);

                setTimeout(function () {
                    // Eğer diğer scriptler/tasarımcı kodları preventDefault çağırdıysa yönlendirme yapmıyoruz
                    if (!userPrevented) {
                        window.location.href = target.href;
                    }
                }, 300);
            }
        }
    }, true); // e.stopPropagation() engeline takılmamak için capture (true) modunda dinliyoruz

    // ==========================
    // ADD TO CART (API/EVENT BASED)
    // ==========================
    PM.on("add.cart", function (params) {
        params = params || {};

        // 1. Ürün ID / Stok Kodu (content_ids) tespiti
        let productId = params.urun_id || params.uid || params.id || params.alt_urun_id || params.product_id || "";

        if (!productId) {
            const adsParams = window.google_tag_params;
            if (adsParams && adsParams.ecomm_prodid) {
                productId = Array.isArray(adsParams.ecomm_prodid) ? adsParams.ecomm_prodid[0] : adsParams.ecomm_prodid;
            }
        }
        if (!productId) {
            try {
                const schemaEl = document.querySelector("#pm_schema");
                if (schemaEl) {
                    const schema = JSON.parse(schemaEl.textContent);
                    if (schema && schema.sku) productId = schema.sku;
                }
            } catch (e) { }
        }
        if (!productId) {
            const urunInput = document.querySelector("input[name='urun_id'], input#urun_id, input[name='uid'], input#uid, input[name='alt_urun_id'], input#alt_urun_id");
            if (urunInput && urunInput.value) productId = urunInput.value;
        }
        if (!productId) {
            const pmuMatch = (window.location.pathname || "").match(/-pmu([0-9]+)/i);
            if (pmuMatch) productId = pmuMatch[1];
        }

        productId = productId ? String(productId).trim() : "";

        // 2. Ürün Adı (content_name) tespiti
        let itemName = params.name || params.urun_adi || params.item_name || "";
        if (!itemName) {
            const nameEl = document.querySelector("#PM_urun_detayi h1.urun_ismi, h1.urun_ismi, .urun_detay_sag h1, .urun_ismi");
            if (nameEl) itemName = nameEl.textContent.trim();
        }
        if (!itemName) {
            try {
                const schemaEl = document.querySelector("#pm_schema");
                if (schemaEl) {
                    const schema = JSON.parse(schemaEl.textContent);
                    if (schema && schema.name) itemName = schema.name;
                }
            } catch (e) { }
        }

        // 3. Fiyat tespiti
        let p_price = parsePrice(params.price || "0");
        if (!p_price) {
            p_price = parsePrice(window.google_tag_params?.ecomm_totalvalue || "0");
        }
        if (!p_price) {
            try {
                const schemaEl = document.querySelector("#pm_schema");
                if (schemaEl) {
                    const schema = JSON.parse(schemaEl.textContent);
                    if (schema && schema.offers && schema.offers.price) {
                        p_price = parsePrice(schema.offers.price);
                    }
                }
            } catch (e) { }
        }
        if (!p_price) {
            const priceEl = document.querySelector(".urun_kdvdahil_fiyati, .urun_fiyati, #urun_fiyat, .fiyat, [data-price-wt]");
            if (priceEl) {
                const rawPrice = priceEl.getAttribute("data-price-wt") || priceEl.getAttribute("data-price") || priceEl.textContent.trim();
                p_price = parsePrice(rawPrice);
            }
        }

        const quantity = parseInt(params.quantity || params.adet || getQuantity() || 1, 10);

        const item = {
            item_id: productId,
            item_name: itemName,
            price: p_price,
            quantity: quantity
        };

        trackEvent("add_to_cart", {
            ecommerce: {
                currency: "TRY",
                value: p_price * quantity,
                items: [item]
            }
        });
        updateLocalCart(item, "add");
    });

    // ==========================
    // PRODUCT VIEW
    // ==========================
    PM.OnPage("urun_detay", function () {
        try {
            const schemaEl = document.querySelector("#pm_schema");
            if (!schemaEl) return;

            const schema = JSON.parse(schemaEl.textContent);
            const parsedPrice = parsePrice(schema.offers.price);

            let productId = schema.sku;
            const adsParams = window.google_tag_params;

            if (adsParams && adsParams.ecomm_prodid) {
                productId = Array.isArray(adsParams.ecomm_prodid) ? adsParams.ecomm_prodid[0] : adsParams.ecomm_prodid;
            } else {
                const urunInput = document.querySelector("input[name='urun_id']");
                if (urunInput) productId = urunInput.value;
            }

            trackEvent("view_item", {
                ecommerce: {
                    currency: schema.offers.priceCurrency || "TRY",
                    value: parsedPrice,
                    items: [{
                        item_id: productId,
                        item_name: schema.name,
                        item_brand: schema.brand?.name || undefined,
                        price: parsedPrice,
                        quantity: 1
                    }]
                }
            });
        } catch (e) {
            debugLog("urun_detay JSON Çekilemedi", e);
        }
    });

    // ==========================
    // OTHER EVENTS (CART REMOVE, SIGN UP)
    // ==========================
    PM.on("remove.cart", function (params) {
        const item = {
            item_id: params.id,
            item_name: params.name,
            quantity: parseInt(params.quantity || 1, 10)
        };
        trackEvent("remove_from_cart", {
            ecommerce: {
                currency: "TRY",
                items: [item]
            }
        });
        updateLocalCart(item, "remove");
    });

    PM.on("new.user", function (user) {
        const uye_tip = { "1": "Bireysel", "2": "Kurumsal" };
        trackEvent("sign_up", {
            user_type: uye_tip[user.uye_tip] || "Bilinmiyor"
        });
    });

    // ==========================
    // VIEW CART & CHECKOUT STEPS
    // ==========================
    PM.OnPage("sepet_detayi", function () {
        const products = getProductFromNode();
        localStorage.setItem("ga_sepet", JSON.stringify(products));

        if (products.length !== 0) {
            const totalValue = products.reduce((sum, next) => sum + (parsePrice(next.price) * next.quantity), 0);
            trackEvent("view_cart", {
                ecommerce: {
                    currency: "TRY",
                    value: totalValue,
                    items: mapItems(products)
                }
            });
        }
    });

    // ==========================
    // CHECKOUT FUNNEL (GA4 standardı: begin_checkout → add_shipping_info → add_payment_info → purchase)
    // order_step_1: Adres/Teslimat sayfası — kullanıcı checkout'a girdi
    // order_step_2: Ödeme yöntemi sayfası — kullanıcı teslimat bilgisini tamamladı
    // order_step_3: Sipariş özeti sayfası — standart event yok, purchase öncesi review
    // ==========================

    PM.OnPage("order_step_1", function () {
        // GA4: begin_checkout — kullanıcı checkout sürecine ilk adımı attı
        // Meta: InitiateCheckout | OpenAI: checkout_started
        syncBasketSession();
        const products = JSON.parse(localStorage.getItem("ga_sepet") || "[]");
        if (products.length !== 0) {
            const totalValue = products.reduce((sum, next) => sum + (parsePrice(next.price) * next.quantity), 0);
            trackEvent("begin_checkout", {
                ecommerce: {
                    currency: "TRY",
                    value: totalValue,
                    items: mapItems(products)
                }
            });
        }
    });

    PM.OnPage("order_step_2", function () {
        // GA4: add_shipping_info — kullanıcı adres/teslimat adımını tamamlayıp buraya geldi
        // Duplicate listener önleme flag'i
        if (window._pm_step2_listener_registered) return;
        window._pm_step2_listener_registered = true;

        syncBasketSession();
        const products2 = JSON.parse(localStorage.getItem("ga_sepet") || "[]");
        if (products2.length !== 0) {
            const totalValue2 = products2.reduce((sum, next) => sum + (parsePrice(next.price) * next.quantity), 0);
            trackEvent("add_shipping_info", {
                ecommerce: {
                    currency: "TRY",
                    value: totalValue2,
                    items: mapItems(products2)
                }
            });
        }

        // GA4: add_payment_info — ödeme yöntemi seçilip form submit edildiğinde
        PM.on("process.checkout", function (params) {
            let _option = (params['sot'] || '').replace('os_', '');
            if (_option === 'kredi_karti') {
                _option = ({ "1": "Kredi Kartı Peşin", "2": "Kredi Kartı Taksit", "3": "BKM Express" })[params["kk_odeme_tipi_secimi"]] || _option;
            } else if (_option === 'havale') {
                _option = "Havale";
            } else if (_option === 'kapipda_odeme') {
                _option = "Kapıda Ödeme";
            }

            syncBasketSession();
            const products = JSON.parse(localStorage.getItem("ga_sepet") || "[]");
            if (products.length !== 0) {
                const totalValue = products.reduce((sum, next) => sum + (parsePrice(next.price) * next.quantity), 0);
                trackEvent("add_payment_info", {
                    ecommerce: {
                        currency: "TRY",
                        value: totalValue,
                        payment_type: _option,
                        items: mapItems(products)
                    }
                });
            }
        });
    });

    PM.OnPage("order_step_3", function () {
        // Sipariş özeti/onay sayfası — standart GA4/Meta/OpenAI event yok.
        // Kullanıcı purchase butonuna bastığında siparis_sonu sayfasına geçer ve purchase tetiklenir.
        syncBasketSession(); // localStorage senkronizasyonu purchase için güvenli kalsın
    });

    // ==========================
    // PURCHASE
    // ==========================
    PM.OnPage("siparis_sonu", function () {

        syncBasketSession();
        const products = JSON.parse(localStorage.getItem("ga_sepet") || "[]");

        if (!products.length || typeof google_ecommerce_option === "undefined") return;

        trackEvent("purchase", {
            ecommerce: {
                transaction_id: qs['oid'],
                value: parsePrice(google_ecommerce_option.revenue),
                tax: parsePrice(google_ecommerce_option.tax || '0'),
                shipping: parsePrice(google_ecommerce_option.shipping || '0'),
                currency: "TRY",
                items: mapItems(products)
            }
        });

        localStorage.removeItem("ga_sepet");
    });

    // ==========================
    // PAGE VIEW
    // ==========================

    PM.OnPage("*", function () {
        trackEvent("page_view", {});
    });

})();

// ==============================
// HELPERS
// ==============================
function parsePrice(price) {
    if (price === null || price === undefined || price === "") return 0;
    if (typeof price === 'number') return price;

    let str = price.toString().trim();

    if (str.includes(',') && str.includes('.')) {
        if (str.lastIndexOf(',') > str.lastIndexOf('.')) {
            str = str.replace(/\./g, '').replace(',', '.');
        } else {
            str = str.replace(/,/g, '');
        }
    } else if (str.includes(',')) {
        str = str.replace(',', '.');
    }

    return parseFloat(str) || 0;
}

function mapItems(products) {
    return products.map(p => ({
        item_id: p.id,
        item_name: p.name,
        price: parsePrice(p.price),
        quantity: p.quantity
    }));
}

function getQuantity() {
    const el = document.querySelector(".urun_secenekleri input#urun_miktar_secenekleri");
    return el ? parseInt(el.value, 10) : 1;
}

function getQueryVariable(query) {
    var result = {};
    if (!query) return result;

    query.split('&').forEach(pair => {
        if (!pair) return;
        const [key, val] = pair.split('=');

        let decodedKey = key;
        let decodedVal = val || '';

        try {
            decodedKey = decodeURIComponent(key);
        } catch (e) {
            try { decodedKey = unescape(key); } catch (err) { }
        }

        try {
            decodedVal = decodeURIComponent(val || '');
        } catch (e) {
            try { decodedVal = unescape(val || ''); } catch (err) { }
        }

        result[decodedKey] = decodedVal;
    });
    return result;
}

function getProductFromNode() {
    return $(".sepet_urunler tbody tr").map(function (i, e) {
        const idHref = $('a[href*="-pmu"]', e).attr("href") || "";
        const idMatch = idHref.match(/pmu([0-9]+)/i);
        const nameAttr = $('a[href*="-pmu"]', e).attr('title') || "";
        const priceAttr = $('td[data-price-wt]', e).data('price-wt');
        const qtyVal = $('input#birim', e).val();

        return {
            id: idMatch ? idMatch[1] : "",
            price: priceAttr !== undefined ? priceAttr.toString() : "0",
            name: nameAttr.trim(),
            quantity: parseInt(qtyVal, 10) || 1
        };
    }).toArray().filter(function (p) { return p.id !== ""; }); // Boş ID'li satırları temizle
}

function updateLocalCart(item, action) {
    syncBasketSession();
    let cart = JSON.parse(localStorage.getItem("ga_sepet") || "[]");

    const qty = parseInt(item.quantity || 1, 10);

    if (action === "add") {
        let existing = cart.find(p => p.id == item.item_id);
        if (existing) {
            existing.quantity += qty;
        } else {
            cart.push({
                id: item.item_id,
                name: item.item_name || "",
                price: item.price !== undefined ? item.price.toString() : "0",
                quantity: qty
            });
        }
    } else if (action === "remove") {
        let existingIndex = cart.findIndex(p => p.id == item.item_id);
        if (existingIndex > -1) {
            cart[existingIndex].quantity -= qty;
            if (cart[existingIndex].quantity <= 0) {
                cart.splice(existingIndex, 1);
            }
        }
    }

    localStorage.setItem("ga_sepet", JSON.stringify(cart));
}

function syncBasketSession() {
    const csrfToken = (typeof PM !== "undefined" && PM.CSRFToken) ? PM.CSRFToken : null;
    const localBasketId = localStorage.getItem("ga_basket_id");

    if (csrfToken) {
        if (!localBasketId) {
            localStorage.setItem("ga_basket_id", csrfToken);
        } else if (localBasketId !== csrfToken) {
            localStorage.removeItem("ga_sepet");
            localStorage.setItem("ga_basket_id", csrfToken);
            if (typeof debugLog === "function") debugLog("Basket ID changed (CSRF token). Cleared ga_sepet.");
        }
    }
}
